<template>
  <div class="app-container">
    <div class="flx-between">
      <div class="flex">
        <!-- 批量撤回-->
        <el-popover
          placement="bottom-start"
          trigger="hover"
          style="margin-left: 10px;"
        >
          <div style="display: flex; flex-direction: column; gap: 10px;">
            <el-button
              plain size="small"
              @click="downloadFile"
            >{{ $t('basicData.DownloadTheTemplate') }} </el-button>
            <UploadExcel
              :on-success="importLogistics"
              :but-name="$t('collectionCenter.Import')"
              style="width:100%"
            />
          </div>
          <el-button
            v-if="isRevoke"
            slot="reference"
            v-permit:remove="'btn:receivableManagementSite:toExamine:recall'"
            size="small"
            style="margin-right: 10px;"
          >{{ $t('receivablePayable.batchWithdrawal') }}</el-button>
        </el-popover>
        <!--导出-->
        <el-button
          v-permit:remove="'btn:receivableManagementSite:toExamine:exportDetail'"
          size="small" type="primary"
          @click="operationBtn"
        >{{ $t('receivablePayable.Export') }}
        </el-button>
        <!--自定义栏目-->
        <CustomStatusBar
          :columns-data="DETAIL_TABLE_HEADER"
          :params="searchParams"
          :save-params="customParams"
          @updateColumns="updateColumns"
        />
      </div>
      <!--查询-->
      <el-button
        icon="el-icon-search" size="small" type="primary"
        @click="searchResources()"
      >{{ $t('receivablePayable.Search') }}
      </el-button>
    </div>
    <el-divider />
    <div v-loading="alertLoading" class="alert">
      <i class="el-icon-info icon" />
      <p>
        <span class="title">{{ $t('receivablePayable.totalReceivable') }}/{{ $t('receivablePayable.transactionCount') }}： </span>
        <span class="num">{{ totalFee }}/{{ totalCount }}</span>
      </p>
      <p>
        <span class="title">{{ $t('receivablePayable.reconciledAmount') }}/{{ $t('receivablePayable.transactionCount') }}： </span>
        <span class="num">{{ paidFee }}/{{ paidCount }}</span>
      </p>
      <p>
        <span class="title">{{ $t('receivablePayable.unreconciledAmount') }}/{{ $t('receivablePayable.transactionCount') }}： </span>
        <span class="num">{{ unpaidFee }}/{{ unpaidCount }}</span>
      </p>
    </div>
    <div>
      <TableCmp
        :table-data="tableData"
        :current-columns="currentColumns"
        :get-current-columns="getCurrentColumns"
        :page-number="queryForm.pageNumber"
        :page-size="queryForm.pageSize"
        :batch-number="batchNumber"
        :is-withdraw="true"
        @selection-change="handleSelectionChange"
        @query-page="queryDetail"
      />
      <!-- 分页工具 -->
      <div class="pagination">
        <el-pagination
          :current-page.sync="queryForm.pageNumber"
          :page-size.sync="queryForm.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="margin: 10px 0"
          @current-change="getExamineTableData"
          @size-change="getExamineTableData"
        />
      </div>
    </div>
    <!--  查询  -->
    <el-drawer
      :append-to-body="true"
      :title="$t('receivablePayable.Search')"
      :visible.sync="showSearch"
      custom-class="drawerClass"
      direction="rtl"
      size="50%"
    >
      <SearchForm
        :is-read-only="true"
        :select-key="1"
        :bill-batch-number="batchNumber"
        :handler-id="handlerId"
        @search="searchFun"
        @close="showSearch = false"
      />
    </el-drawer>
  </div>
</template>

<script>
import {
  apiExportCustomerBills,
  apiSiteExpenseDetailTotal,
  apiSiteExpenseGetPage,
  apiSiteBatchWithdraw
} from '@/api/finance/receivables';
import { goFileUploadManagement, goFinanceExportPage } from '@/utils/goExportList.js';
import { getUserIdAndNameObj } from '@/enums/storageEnum';
import { CARGO_TYPE } from '@/views/finance/basicData/quotationManagement/cmp/utils';
import { DETAIL_TABLE_HEADER, removeDuplicates } from '@/views/finance/receivableManagementSite/toExamine/utils';
import { BH_ORDER_TYPE_LIST, getIsAuth, ORDER_TYPE_LIST, WAYBILL_STATUS } from '@/views/finance/utils';
import { QUERY_PARAMS } from '@/views/finance/receivableManagementSite/aRGenerationNew/utils';
import { cloneDeep } from 'lodash-es';
const ExcelJS = require('exceljs');
import { saveAs } from 'file-saver';

export default {
  components: {
    CustomStatusBar: () => import('@/components/customStatusBar/index.vue'),
    SearchForm: () => import('@/views/finance/receivableManagementSite/cmp/searchForm/index.vue'),
    TableCmp: () => import('@/views/finance/receivableManagementSite/cmp/table.vue'),
    UploadExcel: () => import('@/components/UploadExcel/index.vue')
  },
  props: {
    // 批次号
    batchNumber: {
      type: String,
      default: ''
    },
    // 列表详情
    billBatchData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      CARGO_TYPE,
      // 物流订单
      WAYBILL_STATUS,
      // 揽收订单
      ORDER_TYPE_LIST,
      // 备货揽收订单
      BH_ORDER_TYPE_LIST,
      DETAIL_TABLE_HEADER, // 详情表头配置项
      queryForm: {
        orderDirection: 'DESC',
        orderProperty: '',
        pageNumber: 1,
        pageSize: 10,
        params: {
          ...QUERY_PARAMS
        }
      },
      total: 0,
      tableData: [],
      currentColumns: [],
      getCurrentColumns: [],
      selectData: [],
      showSearch: false,
      searchParams: {
        type: 0,
        menuEnum: 'companyToSiteReviewDetails'
      },
      customParams: {
        templateField: '',
        templateName: '应收账单审核详情',
        userId: '',
        ...this.searchParams
      },
      handlerId: '', // 经办人
      alertLoading: false, // 总费用loading
      totalFee: 0,
      totalCount: 0,
      paidFee: 0,
      paidCount: 0,
      unpaidFee: 0,
      unpaidCount: 0
    };
  },
  computed: {
    // 是否可撤回
    // 仅撤回当前登录人生成批次且为待对账、部分对账
    isRevoke() {
      return this.$store.state.user.id === this.billBatchData.createUser && [0, 4].includes(this.billBatchData.auditStatus);
    }
  },
  created() {
    this.createUser = getUserIdAndNameObj();
    this.queryForm.params.billBatchNumber = this.batchNumber;
    this.getExamineTableData();
    this.getExpenseSubTotal();

    // 经办人是否存在禁用，如果禁用则只能查看当前当前登陆人
    {
      const isBool = getIsAuth('btn:aRGeneration:onlyAgent');
      if (isBool) {
        this.handlerId = this.$store.getters.userId;
      }
    }
  },
  methods: {
    // 更新自定义栏目columns
    updateColumns(list) {
      this.$nextTick(() => {
        this.currentColumns = cloneDeep(list);
      });
    },
    // 列表数据勾选
    handleSelectionChange(arr) {
      this.selectData = arr;
    },
    // 撤回后操作
    queryDetail() {
      this.getExamineTableData();
      this.getExpenseSubTotal();
    },
    // 导出操作
    operationBtn() {
      const ids = [];
      this.selectData.map(list => {
        ids.push(list.id);
      });
      const prop = [];
      const label = [];
      this.currentColumns.forEach(item => {
        if (item.prop !== 'customerAlias') {
          prop.push(item.prop);
          label.push(item.label);
        }
      });
      // 添加对账状态列
      prop.push('isGenReceipt');
      label.push('对账状态');
      const param = {
        ...this.queryForm.params,
        fieldList: prop,
        headList: label,
        ids: ids
      };
      apiExportCustomerBills(param).then(res => {
        if (res.code === 200) {
          return goFinanceExportPage();
        }
      }).then(res => {
        if (res) {
          this.$emit('closeDetail');
        }
      }).catch(err => {
        console.error(err);
      });
    },
    // 打开查询弹窗
    searchResources() {
      this.showSearch = true;
    },
    // 查询
    searchFun(params) {
      console.log(params, '查询条件');
      this.showSearch = false;
      Object.assign(this.queryForm.params, { ...params });
      this.queryForm.pageNumber = 1;
      this.getExamineTableData();
    },
    // 获取列表
    getExamineTableData() {
      const param = cloneDeep(this.queryForm);
      this.getCurrentColumns = [];
      // 获取列表数据
      apiSiteExpenseGetPage(param).then(resp => {
        if (resp.code === 200) {
          this.tableData = resp.data.map(arr => {
            const findStatusLabel = (list, key, value, labelKey) => {
              const found = list.find(item => item[key] === value);
              return found ? found[labelKey] : '';
            };

            // 确保 status 存在且不为空
            if (!arr.status) {
              arr.status = '';
              return arr;
            }

            // 根据业务类型和揽收类别设置状态
            if ((arr.businessType === 0 || arr.businessType === 7)) {
              /**
               * 1、业务类型 businessType 为 0，订单状态展示【物流订单】的运单状态
               */
              arr.status = findStatusLabel(this.WAYBILL_STATUS, 'code', arr.status, 'label');
            } else if (arr.businessType === 1 && arr.collectionCategory === 0) {
              /**
               * 2、业务类型 businessType 为 1，且揽收类别 collectionCategory 为 0，订单状态展示【揽收订单】的订单状态
               */
              arr.status = findStatusLabel(this.ORDER_TYPE_LIST, 'collectStatus', arr.status, 'collectStatusName');
            } else if (arr.businessType === 1 && arr.collectionCategory === 1) {
              /**
               * 3、业务类型 businessType 为 1，且揽收类别 collectionCategory 为 1，订单状态展示【备货揽收订单】的订单状态
               */
              arr.status = findStatusLabel(this.BH_ORDER_TYPE_LIST, 'collectStatus', arr.status, 'collectStatusName');
            } else {
              arr.status = '';
            }
            return arr;
          });
          this.total = resp.total;
          if (resp.data.length > 0) {
            this.getCurrentColumns = [];
            resp.columns.map(item => {
              const obj = {
                prop: item.prop,
                label: item.label,
                width: 160,
                fixed: 'left',
                highlight: false
              };
              this.getCurrentColumns.push(obj);
            });
          }
        }
      }).catch(err => {
        console.error(err);
      });
    },
    /**
     * @description 获取费用统计
     */
    getExpenseSubTotal() {
      this.alertLoading = true;
      const param = cloneDeep(this.queryForm.params);
      apiSiteExpenseDetailTotal({
        billBatchNumber: param.billBatchNumber
      }).then((res) => {
        this.totalFee = res.data.totalFee;
        this.totalCount = res.data.totalCount;
        this.paidFee = res.data.paidFee;
        this.paidCount = res.data.paidCount;
        this.unpaidFee = res.data.unpaidFee;
        this.unpaidCount = res.data.unpaidCount;
      }).finally(() => {
        this.alertLoading = false;
      });
    },
    // 下载模板
    downloadFile() {
      const that = this;
      async function ddd() {
        const wb = new ExcelJS.Workbook();
        const Sheet1 = wb.addWorksheet('Sheet1');
        Sheet1.columns = [
          {
            header: '业务单号',
            key: 'waybillNumber',
            width: 80
          },
          {
            header: '订单号',
            key: 'orderNumber',
            width: 40
          }
        ];
        Sheet1.getCell('A2').value = 'número do negócio';
        Sheet1.getCell('B2').value = 'Número do pedido';
        Sheet1.mergeCells('A3:B3');
        Sheet1.getCell('A3').value = `
          1、每次仅导入 150000 条 /Importar apenas 150000 itens de cada vez
          2、必填 /Obrigatório
          3、不可更改此模板 /Esse modelo não pode ser alterado
        `;
        Sheet1.getRow(3).height = 60;
        Sheet1.getRow(3).getCell(1).style = {
          font: {
            color: { argb: 'ff0000' }
          },
          alignment: {
            vertical: 'bottom', // 垂直居中
            horizontal: 'left', // 水平左对齐
            wrapText: true // 自动换行
          }
        };
        const buffer = await wb.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: 'application/octet-stream'
        });
        const saveName = that.$t('receivablePayable.batchWithdrawal') + that.$t('receivablePayable.template') + '.xlsx';
        saveAs(blob, saveName);
      }
      ddd();
    },
    // 导入
    importLogistics(arr) {
      const excelData = arr[0].results.slice(2);
      console.log(excelData, '导入数据');
      const headObj = {
        '业务单号': 'waybillNumber',
        '订单号': 'orderNumber'
      };
      const dataList = [];

      for (const item of excelData) {
        const data = {};
        try {
          for (const key of Object.keys(item)) {
            if (headObj[key]) {
              data[headObj[key]] = item[key] + '';
            }
            // data[headObj[key] || key] = item[key] || '';
          }
        } catch (error) {
          console.error(error);
          this.$message.error(this.$t('basicData.dataProcessingError'));
          return;
        }
        dataList.push(data);
      }
      console.log(dataList);
      if (!dataList.length) {
        return this.$message.error(this.$t('GlobalSetObj.required'));
      }
      if (dataList.length > 150000) {
        return this.$message.error(this.$t('receivablePayable.singleImportLimit', { size: 150000 }));
      }
      const flags = dataList.every(item => {
        return item.waybillNumber && item.orderNumber;
      });
      console.log(flags);
      if (!flags) {
        return this.$message.error(this.$t('GlobalSetObj.required'));
      }
      // 去重业务单号+订单号
      console.log(removeDuplicates(dataList, 'waybillNumber', 'orderNumber'));
      apiSiteBatchWithdraw({
        billBatchNumber: this.batchNumber,
        feeCondition: removeDuplicates(dataList, 'waybillNumber', 'orderNumber')
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success(this.$t('basicData.TheOperationSucceeded'));
          goFileUploadManagement(this).then(flag => {
            if (flag) {
              this.$emit('closeDetail');
            } else {
              this.queryDetail();
            }
          });
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.alert {
  background-color: #e6f7ff;
  border: 1px solid #91d5ff;
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 6px 16px;
  margin-bottom: 5px;

  p:nth-child(3),
  p:nth-child(4) {
    color: red;
  }
}

.alert p {
  margin: 0;
  padding: 0 15px 0 0;
}

.alert .icon {
  color: #00A551;
  font-size: 24px;
}

.alert .title {
  font-size: 14px;
}

.alert .num {
  font-weight: 600;
  font-size: 14px;
}

.alert .signal {
  color: #00A551;
}
</style>
